import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import DateTime from '../../helpers/DateTime';
import { NoTopSlot } from '../../interfaces/NoTopSlot';
import Card from '../Card/Card';
import styles from './NoSlotsSummary.module.scss';

interface NoSlotButtonProps {
  selectedNoTopSlots: NoTopSlot[];
}

const NoSlotsSummary: FC<NoSlotButtonProps> = ({ selectedNoTopSlots }) => {
  const { t } = useTranslation();

  return (
    <Card className={styles.warningContainer}>
      <div className={styles.warningText}>
        <p className={styles.warningTitle}>
          {t('confirmSection:selectedNoTopSlotsContentCardTitle')}
        </p>
        <table className={styles.table}>
          <tbody>
            {selectedNoTopSlots.map(({ day, periods }) => (
              <tr className={styles.slotRow} key={day}>
                <td>
                  {DateTime.formatDate('EEEE dd LLLL', new Date(day))}
                </td>
                <td className={styles.timeslots}>
                  {periods.map(({ from, to }, index) => (
                    <div className={styles.timeSlot} key={index}>
                      {t('slots:selectedAppointmentTimeRange', {
                        startTime: DateTime.getTimeStringFromDate(DateTime.roundToNearestMinutes(from)),
                        endTime: DateTime.getTimeStringFromDate(DateTime.roundToNearestMinutes(to)),
                      })}
                    </div>
                  ))}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

      </div>
    </Card>
  );
};

export default NoSlotsSummary;
